import { updateItems } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">最新动态</h2>
          <p className="mt-3 text-sm text-foreground-600">平台内容更新与技术升级一手掌握</p>
        </div>
        <div className="relative">
          <div className="absolute left-5 md:left-8 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-5 md:gap-8 pl-12 md:pl-16">
                <div className={`absolute left-3.5 md:left-6.5 w-3.5 h-3.5 md:w-4 md:h-4 rounded-full border-2 border-background-50 ${
                  idx < 2 ? 'bg-primary-500' : 'bg-background-400'
                }`} style={{left: idx < 2 ? 'calc(1.1rem - 2px)' : 'calc(1.1rem - 2px)'}}></div>
                <div className="flex-shrink-0 w-24 md:w-28">
                  <span className="text-xs font-medium text-foreground-500">{item.date}</span>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200/70 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                      item.type === '更新' ? 'bg-primary-500/10 text-primary-600' :
                      item.type === '上新' ? 'bg-accent-500/10 text-accent-600' :
                      item.type === '专题' ? 'bg-accent-500/10 text-accent-600' :
                      'bg-secondary-500/10 text-secondary-600'
                    }`}>
                      {item.type}
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-800">{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}